import React from 'react'
import { useNavigate } from 'react-router-dom'
import logo from '../images/iloveimagpedf logo.png'

function Logo() {
  const navigate = useNavigate()
  return (
    <div className="logo" onClick={() => navigate('/')}>
      <img src={logo} alt="iLoveImgPdf" className="logo-img" />
    </div>
  )
}

export default Logo
